import { render, staticRenderFns } from "./Cuservices.vue?vue&type=template&id=5d614f60&scoped=true"
import script from "./Cuservices.vue?vue&type=script&lang=js"
export * from "./Cuservices.vue?vue&type=script&lang=js"
import style0 from "./Cuservices.vue?vue&type=style&index=0&id=5d614f60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d614f60",
  null
  
)

export default component.exports